import React from 'react';

// ant
import { Card, Button, Table, Space, Input } from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';

// components
import ButtonTooltip from '../common/ButtonTooltip';
import ButtonPopconfirm from './../common/ButtonPopconfirm';

const { Column } = Table;

class EstudiosTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {
    return (
      <Card
        title="Lista de estudios"
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={this.props.addEstudio}
          >
            Agregar
          </Button>
        }
      >
        <Table
          dataSource={this.props.estudios}
          size="small"
          width="auto"
          height="auto"
          pagination={{ pageSize: 20 }}
          scroll={{ x: 1000 }}
          rowKey="Id"
        >
          <Column
            title="Nombre"
            dataIndex="Nombre"
            // sorter={{ compare: (a, b) => a.Nombre.localeCompare(b.Nombre) }}
            {...this.getColumnSearchProps('Nombre')}
          />
          <Column
            title="Información"
            dataIndex="Informacion"
            {...this.getColumnSearchProps('Informacion')}
          />
          <Column
            title="Precio"
            dataIndex="Precio"
            width={100}
            align="right"
            {...this.getColumnSearchProps('Precio')}
          />
          <Column
            title="Notas"
            dataIndex="Notas"
            {...this.getColumnSearchProps('Notas')}
          />
          <Column
            title="Estado"
            dataIndex="Estado"
            {...this.getColumnSearchProps('Estado')}
          />
          <Column
            title="Acciones"
            width={100}
            fixed="right"
            render={(text, record) => (
              <>
                <ButtonTooltip
                  icon={EditOutlined}
                  title="Editar"
                  onClick={() => this.props.editEstudio(record)}
                />
                <ButtonPopconfirm
                  icon={DeleteOutlined}
                  title="¿Desea eliminar el estudio seleccionado?"
                  tooltip="Eliminar"
                  onConfirm={() => this.props.deleteEstudio(record.Id)}
                />
              </>
            )}
          />
        </Table>
      </Card>
    );
  }
}

EstudiosTable.defaultProps = {};

EstudiosTable.propTypes = {};

export default EstudiosTable;
